import { render } from "./CommunitiesImportView.vue?vue&type=template&id=1d0d7bcb"
import script from "./CommunitiesImportView.vue?vue&type=script&lang=js"
export * from "./CommunitiesImportView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__